var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStateIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 46,
    viewBox: "0 0 64 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.835938,
    y: 45.7927,
    width: 45.5705,
    height: 5.33287,
    rx: 2.66644,
    transform: "rotate(-90 0.835938 45.7927)",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.835938,
    y: 45.7927,
    width: 37.508,
    height: 5.33288,
    rx: 2.66644,
    transform: "rotate(-90 0.835938 45.7927)",
    fill: "#456EFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.168,
    y: 45.7927,
    width: 45.5705,
    height: 5.33287,
    rx: 2.66644,
    transform: "rotate(-90 15.168 45.7927)",
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.168,
    y: 45.7927,
    width: 23.4863,
    height: 5.33287,
    rx: 2.66643,
    transform: "rotate(-90 15.168 45.7927)",
    fill: "#456EFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.502,
    y: 45.7927,
    width: 45.5705,
    height: 5.33286,
    rx: 2.66643,
    transform: "rotate(-90 29.502 45.7927)",
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29.502,
    y: 45.7927,
    width: 31.5488,
    height: 5.33287,
    rx: 2.66643,
    transform: "rotate(-90 29.502 45.7927)",
    fill: "#456EFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 43.834,
    y: 45.7927,
    width: 45.5705,
    height: 5.33281,
    rx: 2.66641,
    transform: "rotate(-90 43.834 45.7927)",
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 43.834,
    y: 45.7927,
    width: 41.364,
    height: 5.33287,
    rx: 2.66643,
    transform: "rotate(-90 43.834 45.7927)",
    fill: "#456EFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 58.168,
    y: 45.7927,
    width: 45.5705,
    height: 5.33286,
    rx: 2.66643,
    transform: "rotate(-90 58.168 45.7927)",
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 58.168,
    y: 45.7927,
    width: 10.8668,
    height: 5.33286,
    rx: 2.66643,
    transform: "rotate(-90 58.168 45.7927)",
    fill: "#456EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateIcon1);
export default __webpack_public_path__ + "static/media/stateIcon-1.116377529b508476c6f3e012987717a2.svg";
export { ForwardRef as ReactComponent };